import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { Checkbox, FormControlLabel, CircularProgress } from '@material-ui/core';

function AddRemoveList({
    addItem,
    removeItem,
    itemList,
    activeItemList,
    idColumn,
    nameColumn,
    isItemLoading,
}) {
    const isItemActive = (itemId) => {
        return activeItemList.find((x) => String(x[idColumn]) === String(itemId));
    };

    const onItemChange = async (itemEvent) => {
        if (itemEvent.target.checked) {
            await addItem(itemEvent.target.name);
        } else {
            await removeItem(itemEvent.target.name);
        }
    };

    return (
        <Grid
            container
            direction="column"
            justify="center"
            align="center"
            spacing={2}
        >
            {itemList.map((item, k) => {
                const itemId = item[idColumn];
                const isLoading = isItemLoading ? isItemLoading(itemId) : false;
                
                return (
                    <Grid item key={k} xs={12}>
                        <FormControlLabel
                            control={
                                isLoading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    <Checkbox
                                        checked={isItemActive(itemId)}
                                        onChange={onItemChange}
                                        name={itemId}
                                        disabled={isLoading}
                                    />
                                )
                            }
                            label={item[nameColumn]}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default observer(AddRemoveList);
